<template>
  <div v-if="organizationToEdit" class="organization-edit app-form-styling simple-form width-content flex column align-start gap40 width-all">
    <!-- <h2 v-if="organizationToEdit._id">{{$t('organizationLocales.editOrganization')}}</h2> -->
    <h2 v-if="organizationToEdit._id">{{$t(organizationToEdit.type === 'musicArtist' ? 'musicArtistLocales.artistSettings' : 'organizationLocales.organizationSettings')}}</h2>
    <h2 v-else>{{$t(organizationToEdit.type === 'musicArtist' ? 'musicArtistLocales.createArtist' : 'organizationLocales.createOrganization')}}</h2>
    <form v-if="organizationToEdit" @submit.prevent="" class="flex column width-all gap50 align-start">
      <div class="input-container">
        <p>{{$t(organizationToEdit.type === 'musicArtist' ? 'musicArtistLocales.artistName' : 'organizationLocales.name')}}</p>
        <FormInput type="text" :placeholder="organizationToEdit.type === 'musicArtist' ? 'musicArtistLocales.artistName' : 'organizationLocales.name'" v-model="organizationToEdit.name"/>
      </div>

      <div class="flex column gap20 align-start" v-if="organizationToEdit.type !== 'musicArtist' && (isNewOrg || organizationToEdit.templateMode === 'schema')">
        <div class="template-wizard-card">
          <p class="template-wizard-title">{{$t('organizationLocales.templateWizard.title')}}</p>
        <div class="flex gap20 wrap">
          <FormInput
            type="select"
            labelholder="organizationLocales.templateWizard.startModeLabel"
            :items="[
              { label: 'organizationLocales.templateWizard.startBlank', value: 'blank' },
              { label: 'organizationLocales.templateWizard.startFromDefaultTemplate', value: 'template' }
            ]"
            v-model="schemaWizard.startMode"
          />
          <FormInput
            type="checkbox"
            labelholder="organizationLocales.templateWizard.enableSchemaModeForOrg"
            v-model="schemaWizard.enabled"
          />
        </div>

        <div v-if="schemaWizard.enabled" class="flex column gap30 width-all">
          <div class="flex column gap10">
            <p class="template-wizard-section">{{$t('organizationLocales.templateWizard.stage1ChooseElements')}}</p>
            <div class="flex column gap10">
              <FormInput type="checkbox" labelholder="organizationLocales.templateWizard.stage1TitleField" v-model="schemaWizard.elements.title.enabled" :disabled="true"/>
              <FormInput type="checkbox" labelholder="organizationLocales.templateWizard.stage1SubTitleField" v-model="schemaWizard.elements.subTitle.enabled" :disabled="true"/>
              <FormInput type="checkbox" labelholder="organizationLocales.templateWizard.stage1MainImageField" v-model="schemaWizard.elements.mainImage.enabled" :disabled="true"/>
              <FormInput type="checkbox" labelholder="organizationLocales.templateWizard.stage1ContentField" v-model="schemaWizard.elements.content.enabled" :disabled="true"/>
              <FormInput type="checkbox" labelholder="organizationLocales.templateWizard.stage1SectionsField" v-model="schemaWizard.elements.sections.enabled"/>

              <div v-if="schemaWizard.elements.sections.enabled" class="flex column gap10 template-wizard-divider">
                <p class="template-wizard-subsection">{{$t('organizationLocales.templateWizard.elements.section.textItems')}}</p>
                <FormInput type="checkbox" labelholder="organizationLocales.templateWizard.stage1SectionTypeTextItems" v-model="schemaWizard.sectionTypes.textItems.enabled"/>
                <FormInput type="checkbox" labelholder="organizationLocales.templateWizard.stage1SectionTypeImages" v-model="schemaWizard.sectionTypes.images.enabled"/>
                <FormInput type="checkbox" labelholder="organizationLocales.templateWizard.stage1SectionTypeVideos" v-model="schemaWizard.sectionTypes.videos.enabled"/>
                <FormInput type="checkbox" labelholder="organizationLocales.templateWizard.stage1SectionTypeLinks" v-model="schemaWizard.sectionTypes.links.enabled"/>
              </div>
            </div>
          </div>

          <div class="flex column gap10">
            <p class="template-wizard-section">{{$t('organizationLocales.templateWizard.stage2LabelsAndShowHide')}}</p>
            <div class="flex column gap15">
              <div class="flex gap20 wrap align-center" v-for="el in schemaWizardElementRows" :key="el.key">
                <p class="template-wizard-row-key">{{$t(el.labelKey)}}</p>
                <FormInput type="text" labelholder="organizationLocales.templateWizard.stage2Label" v-model="el.state.label"/>
                <FormInput type="checkbox" labelholder="organizationLocales.templateWizard.stage2ShowTitle" v-model="el.state.showTitle"/>
              </div>
            </div>
          </div>

          <div class="flex column gap10" v-if="schemaWizard.elements.sections.enabled">
            <p class="template-wizard-section">{{$t('organizationLocales.templateWizard.stage3SectionsOrder')}}</p>
            <div class="flex column gap10">
              <div class="flex gap10 align-center" v-for="(sec, idx) in sectionsOrderEffective" :key="sec">
                <p class="template-wizard-row-key">{{$t(sectionTypeLabelKey(sec))}}</p>
                <TableActionBtns :value="sectionsOrderEffective" :idx="idx" @input="val => updateSectionsOrderEffective(val)" />
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div class="flex column gap20">
        <p>{{$t('organizationLocales.logo')}}</p>
        <FileUploader v-if="organizationToEdit._id" :uploadFolderName="organizationToEdit._id" :parentData="{col: 'organization', _id: organizationToEdit._id}" :viewAsImg="true" :value="organizationToEdit.logo" @input="val => imgUploaded(val, 'logo')" :rootItem="organizationToEdit"/>
        <p v-else>{{$t('organizationLocales.saveOrgToUploadFilesMsg')}}</p>
      </div>

      <div class="media-links-section flex column gap20 align-start">
        <p>{{$t('organizationLocales.mediaLinks')}}</p>
        <ul class="flex column gap10 table-like">
          <li>
            <p>{{$t('type')}}</p>
            <!-- <p>{{$t('title')}}</p> -->
            <p>{{$t('url')}}</p>
            <p></p>
          </li>
          <li v-for="(curr, idx) in organizationToEdit.mediaLinks || []" :key="idx">
            <FormInput type="select" placeholder="type" v-model="curr.type" :items="['web', 'youtube', 'facebook', 'twitter', 'instegram', 'tiktok', 'spotify', 'appleMusic']"/>
            <!-- <FormInput type="text" placeholder="title" v-model="curr.title"/> -->
            <FormInput type="text" placeholder="url" v-model="curr.src"/>
            <TableActionBtns v-model="organizationToEdit.mediaLinks" :idx="idx" :allowEmptyArray="true"/>
          </li>
        </ul>
        <button @click="AddMediaLinkItem" class="btn big">{{$t('add')}}</button>
      </div>
          
      <div class="flex column gap20 align-start">
        <p>{{$t('organizationLocales.contactMsg')}}</p>
        <FormInput type="textarea" class="contact-msg-input align-start" placeholder="organizationLocales.contactMsg" v-model="organizationToEdit.designPreferences.contactMsg"/>
      </div>

      <div class="flex column gap20 align-start" v-if="isLoggedUserAdmin">
        <p>{{$t('organizationLocales.design')}}</p>
        <div class="flex column space-between_ gap100_ gap20">
          <FormInput v-model="organizationToEdit.allowDesignSelection" type="checkbox" labelholder="organizationLocales.allowDesignSelection" class="width-content_"/>
          <FormInput v-model="designTemplateId" type="radio" :items="getAllRelevantTemplatesForReleaseType(organizationToEdit?.releaseTypes[0]?.id, organizationToEdit, 'landingPage', true).map(c => ({value: c.id, label: c.name}))"/>
          
          <!-- RIGHTER, BUT NOT AS NiCE; -->
          <!-- <div class="flex column gap20" v-for="templateType in ['landingPage', 'email']" :key="templateType">
            <p>{{$t('organizationLocales.design-' + templateType)}}</p>
            <div class="flex gap30">
              <div class="flex column gap10" v-for="releaseType in organizationToEdit.releaseTypes" :key="releaseType.id">

                <p>{{releaseType.name}}</p>
                <FormInput v-model="organizationToEdit.defaultTemplates[releaseType.id][templateType]" type="radio" :items="getAllRelevantTemplatesForReleaseType(releaseType.id, organizationToEdit, templateType, true).map(c => ({value: c.id, label: c.name}))"/>
              </div>
            </div>
          </div> -->
        </div>
      </div>



      <div class="from-emails-section flex column gap20 align-start">
        <p>{{$t('organizationLocales.fromEmails')}}</p>
        <ul class="emails flex column gap10 table-like">
          <li>
            <p>{{$t('email')}}</p>
            <p>{{$t('name')}}</p>
            <p>{{$t('distributeLocales.allowReply')}}</p>
            <p></p>
          </li>
          <li v-for="(curr, idx) in organizationToEdit.fromEmails || []" :key="idx">
            <FormInput type="text" placeholder="name" v-model="curr.email"/>
            <FormInput type="text" placeholder="name" v-model="curr.title"/>
            <FormInput type="checkbox" placeholder="distributeLocales.allowReply" class="width-content" v-model="curr.allowReply"/>
            <TableActionBtns v-model="organizationToEdit.fromEmails" :idx="idx" :allowEmptyArray="true"/>
          </li>
        </ul>
        <button @click="addFromEmailItem" class="btn big">{{$t('add')}}</button>
      </div>


      <template v-if="organizationToEdit.type !== 'musicArtist'">
        <div class="flex column gap20 align-start">
          <p>{{$t('settingsLocales.settings')}}</p>
          <FormInput type="checkbox" labelholder="organizationLocales.requireAuth" v-model="organizationToEdit.requireAuth"/>
          <FormInput type="checkbox" labelholder="organizationLocales.require2FactorAuth" v-if="organizationToEdit.requireAuth" v-model="organizationToEdit.require2FactorAuth"/>
          <FormInput type="checkbox" labelholder="organizationLocales.useVideoWaterMark" v-model="organizationToEdit.useVideoWaterMark"/>
          <FormInput type="checkbox" labelholder="organizationLocales.useBurnedInWatermark" v-model="organizationToEdit.burnedInWatermarkEnabled"/>
          <FormInput type="text" labelholder="organizationLocales.burnedInWatermarkText" v-model="organizationToEdit.burnedInWatermarkText"/>
        </div>
        
        <!-- NEW: Feature Flags Section -->
        <div class="flex column gap20 align-start" v-if="isLoggedUserAdmin">
          <p>{{$t('organizationLocales.featureFlags')}}</p>
          <div class="flex column gap10">
            <FormInput 
              type="checkbox" 
              labelholder="organizationLocales.encryptedVideosSection" 
              v-model="organizationToEdit.features.encryptedVideosSection"
            />
            <FormInput 
              type="checkbox" 
              labelholder="organizationLocales.releaseLevel2FA" 
              v-model="organizationToEdit.features.releaseLevel2FA"
            />
          </div>
        </div>
        
        <!-- NEW: Storage Configuration Section -->
        <div class="flex column gap20 align-start" v-if="isLoggedUserAdmin">
          <p>{{$t('organizationLocales.storageConfiguration')}}</p>
          <div class="flex column gap10">
            <FormInput 
              type="text" 
              labelholder="organizationLocales.imagesBucketConfig" 
              placeholder="organizationLocales.bucketConfigPlaceholder"
              v-model="organizationToEdit.storage.imagesBucketConfig"
            />
            <FormInput 
              type="text" 
              labelholder="organizationLocales.videosBucketConfig" 
              placeholder="organizationLocales.bucketConfigPlaceholder"
              v-model="organizationToEdit.storage.videosBucketConfig"
            />
            <FormInput 
              type="checkbox" 
              labelholder="organizationLocales.useSignedUrls" 
              v-model="organizationToEdit.storage.useSignedUrls"
            />
            <FormInput 
              type="select" 
              labelholder="organizationLocales.videoEncodingPreset"
              v-model="organizationToEdit.storage.videoEncodingPreset"
              :items="videoEncodingPresetOptions"
            />
          </div>
        </div>
        
        <div class="flex column gap20 align-start" v-if="organizationToEdit.requireAuth || true">
          <p>{{$t('organizationLocales.loginPagePreferences')}}</p>
          <!-- <FileUploader :uploadFolderName="organizationToEdit._id" :viewAsImg="true" :value="{src: organizationToEdit.designPreferences.loginPage[0].bgImg}" @input="val => imgUploaded(val.src, 'designPreferences.loginPage.0.bgImg')"/> -->
          <div class="flex column gap20">
            <p>{{$t('organizationLocales.loginPageBgImage')}}</p>
            <ImageCrop v-if="organizationToEdit._id" :value="organizationToEdit.designPreferences.loginPage[0].bgImg" :uploadFolderName="organizationToEdit._id" :parentData="{col: 'organization', _id: organizationToEdit._id}" @input="val => imgUploaded(val, 'designPreferences.loginPage.0.bgImg')" :rootItem="organizationToEdit"/>
            <p v-else>{{$t('organizationLocales.saveOrgToUploadFilesMsg')}}</p>
          </div>
          <FormInput type="textarea" labelholder="organizationLocales.loginPageMsg" v-model="organizationToEdit.designPreferences.loginPage[0].msg"/>
        </div>

        <template v-if="isLoggedUserAdmin">
          <div class="flex column gap20">
            <div class="input-container">
              <p>{{$t('organizationLocales.defaultGalleryCredit')}}</p>
              <FormInput type="text" placeholder="organizationLocales.defaultGalleryCredit" v-model="organizationToEdit.defaultGalleryCredit"/>
            </div>
            <div class="input-container">
              <p>{{$t('organizationLocales.distributionBcc')}}</p>
              <FormInput type="text" placeholder="organizationLocales.distributionBcc" v-model="organizationToEdit.distributionBcc"/>
            </div>
          </div>

          
          <div class="logos-section flex column gap20 align-start">
            <p>{{$t('organizationLocales.logos')}}</p>
            <ul  v-if="organizationToEdit._id" class="flex column gap10 table-like">
              <li>
                <p>{{$t('name')}}</p>
                <p>{{$t('file')}}</p>
                <p></p>
              </li>
              <li v-for="(curr, idx) in organizationToEdit.logos || []" :key="idx">
                <FormInput type="text" placeholder="name" v-model="curr.title"/>
                <!-- <FileUploader :uploadFolderName="organizationToEdit._id" :onlySrc="true" :viewAsImg="true" :value="curr.url" @input="val => imgUploaded(val, `logos.${idx}.url`)"/> -->
                <FileUploader :uploadFolderName="organizationToEdit._id" :parentData="{col: 'organization', _id: organizationToEdit._id}" :viewAsImg="true" :value="curr" @input="val => imgUploaded(val, `logos.${idx}`)" :rootItem="organizationToEdit"/>
                <TableActionBtns v-model="organizationToEdit.logos" :idx="idx"/>
              </li>
            </ul>
            <p v-else>{{$t('organizationLocales.saveOrgToUploadFilesMsg')}}</p>
            <button @click="addLogoItem" class="btn big">{{$t('add')}}</button>
          </div>
        </template>

        <div class="flex column gap40 align-start" v-if="isLoggedUserAdmin">
            <p>{{$t('organizationLocales.designPreferences')}}</p>

            <div class="flex column gap20" v-for="designAppKey in ['producerApp', 'clientApp', 'newsletter']" :key="designAppKey">
              <p>{{$t('organizationLocales.designPreferencesTypes.' + designAppKey)}}</p>
              <div v-for="theme in organizationToEdit.designPreferences[designAppKey]" :key="theme.id" class="flex column gap10">
                <FormInput type="text" labelholder="name" v-model="theme.name" :disabled="!isLoggedUserDeveloper"/>
                <FormInput type="select" class="gap10" labelholder="inheritTheme" :value="null" :items="allDefaultThemes" @change="val => inheritTheme(theme, val)" v-if="isLoggedUserDeveloper"/>
                <div class="input-container flex gap20">
                  <FormInput type="color" labelholder="organizationLocales.bodyColor" v-model="theme.colors[0]"/>
                  <FormInput type="color" labelholder="organizationLocales.bodyBg" v-model="theme.colors[1]"/>
                  <FormInput type="color" labelholder="organizationLocales.headerColor" v-model="theme.colors[2]"/>
                  <FormInput type="color" labelholder="organizationLocales.headerBg" v-model="theme.colors[3]"/>
                  <FormInput type="color" labelholder="organizationLocales.headersColor" v-model="theme.colors[4]"/>
                  <!-- <FormInput type="color" labelholder="organizationLocales.headersBgColor" v-model="theme.colors[5]"/> -->
                  <FormInput type="color" labelholder="organizationLocales.linkColor" v-model="theme.colors[5]"/>
                  <FormInput type="color" labelholder="organizationLocales.btnColor" v-model="theme.colors[6]"/>
                </div>
                <ToggleModal :fullScreen="true" class="code-edit-modal" v-if="isLoggedUserDeveloper">
                  <template #toggler>
                    <div class="btn">
                      {{$t('css')}}
                    </div>
                  </template>
                  <template #content>
                    <FormInput type="textarea" class="ltr" placeholder="editCssCode" v-model="theme.css"/>
                  </template>
                </ToggleModal>
              </div>
              <button class="btn width-content" @click="addTheme(organizationToEdit.designPreferences[designAppKey])" v-if="isLoggedUserDeveloper">Add theme</button>
            </div>

          </div>
      </template>
      



      <div class="flex column gap50" v-if="isLoggedUserDeveloper">
        <button class="btn big secondary_ align-self-start"><span @click="showDeveloperZone = !showDeveloperZone">DEVELOPER ZONE</span></button>
        <div class="developer-zone flex column gap50" v-if="showDeveloperZone">
          <FormInput type="text" labelholder="inheritFilePath" v-model="organizationToEdit.inheritFilePath"/>
          <FormInput type="text" labelholder="redirectUrl" v-model="organizationToEdit.redirectUrl"/>

          <FormInput type="select" labelholder="type" @change="val => inheritOrgTypeData(val)" v-model="organizationToEdit.type" :items="['tvProducer', 'musicArtist']"/>

          
          <div class="flex column align-start gap20">
            <FormInput :error="isDomainExistsError && $t('organizationLocales.domainTakenError') || ''" type="text" labelholder="organizationLocales.domain" v-model="organizationToEdit.domain"/>
            <FormInput type="select" labelholder="organizationLocales.clientApp" v-model="organizationToEdit.clientApp" :items="allClientAppsNames"/>
            
            <FormInput type="checkbox" title="isStandAlone" labelholder="isStandAlone" v-model="organizationToEdit.isStandAlone"/>
            <FormInput type="checkbox" title="onlyKnownRegistrations" labelholder="onlyKnownRegistrations" v-model="organizationToEdit.onlyKnownRegistrations"/>
            <FormInput type="checkbox" title="useDirectLink" labelholder="useDirectLink" v-model="organizationToEdit.useDirectLink"/>
            <FormInput type="checkbox" title="dontUseGlobalDbData" labelholder="dontUseGlobalDbData" v-model="organizationToEdit.dontUseGlobalDbData"/>
            <FormInput type="checkbox" title="restrictVideos" labelholder="restrictVideos" v-model="organizationToEdit.restrictVideos"/>
          </div>
          <FormInput type="textarea" labelholder="organizationLocales.searchKeys" v-model="organizationToEdit.searchKeys"/>

          
          

          <div class="route-filters-section flex column gap20 align-start">
            <p>{{$t('organizationLocales.routes')}}</p>
            <ul class="flex column gap10 table-like">
              <li>
                <p>{{$t('title')}}</p>
                <p>{{$t('releaseTypes')}}</p>
                <p>{{$t('wasDistributed')}}</p>
                <p>{{$t('deepEditFilter')}}</p>
                <p>{{$t('htmlContentFilePath')}}</p>
                <p>{{$t('showInRoles')}}</p>
                <p></p>
              </li>
              <li v-for="(curr, idx) in organizationToEdit.routes || []" :key="idx">
                <FormInput type="text" placeholder="name" v-model="curr.name"/>
                <FormInput type="multiselect" :items="organizationToEdit.releaseTypes.map(({id, name}) => ({value: id, label: name}))" placeholder="releaseTypes" v-model="curr.releaseFilter.releaseTypes"/>
                <FormInput type="select" :itemsMap="{undefined:undefined, true:true,false:false}" placeholder="wasDistributed" v-model="curr.releaseFilter.wasDistributed"/>
                <ToggleModal :fullScreen="true" class="code-edit-modal">
                  <template #toggler>
                    <div class="btn">
                      {{$t('edit')}}
                    </div>
                  </template>
                  <template #content>
                    <FormInput type="textarea" class="ltr" placeholder="deepEditFilter" :value="JSON.stringify(curr.releaseFilter.filter || {}, null, 2)" @input="val => curr.releaseFilter.filter=JSON.parse(val)"/>
                  </template>
                </ToggleModal>
                <FormInput type="text" placeholder="htmlContentFilePath" v-model="curr.htmlContentFilePath"/>
                <FormInput type="multiselect" :items="userRolesToSelect" placeholder="showInRoles" v-model="curr.showInRoles"/>
                <TableActionBtns v-model="organizationToEdit.routes" :idx="idx"/>
              </li>
            </ul>
            <button @click="addRouteFilterItem" class="btn big">{{$t('add')}}</button>
          </div>

          <div class="inner-filters-section flex column gap20 align-start">
            <p>{{$t('organizationLocales.innerFilters')}}</p>
            <ul class="flex column gap10 table-like">
              <li>
                <p>{{$t('field')}}</p>
                <p>{{$t('title')}}</p>
                <p>{{$t('options')}}</p>
                <p></p>
              </li>
              <li v-for="(curr, idx) in organizationToEdit.innerFilters || []" :key="idx">
                <FormInput type="text" placeholder="field" v-model="curr.field"/>
                <FormInput type="text" placeholder="title" v-model="curr.title"/>
                <!-- <FormInput type="text" placeholder="options" v-model="curr.options"/> -->
                <ToggleModal :fullScreen="true" class="code-edit-modal">
                  <template #toggler>
                    <div class="btn">
                      {{$t('edit JSON')}}
                    </div>
                  </template>
                  <template #content>
                    <FormInput type="textarea" class="ltr" placeholder="edit JSON" :value="JSON.stringify(curr.options, null, 2)" @input="val => curr.options = JSON.parse(val)"/>
                  </template>
                </ToggleModal>
                <TableActionBtns v-model="organizationToEdit.innerFilters" :idx="idx"/>
              </li>
            </ul>
            <button @click="addInnerFilterItem" class="btn big">{{$t('add')}}</button>
          </div>

          <div class="release-types-section flex column gap20 align-start">
            <p>{{$t('organizationLocales.releaseTypes')}}</p>
            <ul class="flex column gap10 table-like">
              <li>
                <!-- <p>{{$t('id')}}</p> -->
                <p>{{$t('name')}}</p>
                <p>{{$t('dataFieldsLocalFilePath')}}</p>
                <p>{{$t('isGroup')}}</p>
                <p>{{$t('followReleaseType')}}</p>
                <!-- <p>{{$t('dataFieldsStr')}}</p> -->
                <p></p>
              </li>
              <li v-for="(curr, idx) in organizationToEdit.releaseTypes || []" :key="idx">
                <!-- <FormInput type="autocomplete" placeholder="id" v-model="curr.id" :items="defaultTemplateTypesIds"/> -->
                <FormInput type="text" placeholder="name" v-model="curr.name"/>
                <FormInput type="text" placeholder="dataFieldsFilePath" v-model="curr.dataFieldsLocalFilePath"/>
                <FormInput type="checkbox" v-model="curr.isGroup"/>
                <FormInput type="select" placeholder="followReleaseType" v-model="curr.followReleaseType" :items="[...allReleaseTypes.map(c => ({ value: c.id, label: c.name })), {label: 'none', value: ''}]"/>
                <!-- <FormInput type="textarea" placeholder="dataFieldsStr" v-model="curr.dataFieldsStr"/> -->
                <TableActionBtns v-model="organizationToEdit.releaseTypes" :idx="idx"/>
              </li>
            </ul>
            <button @click="addReleaseTypeItem" class="btn big">{{$t('add')}}</button>
          </div>
          
          <div class="templates-section flex column gap20 align-start">
            <p>{{$t('organizationLocales.templates')}}</p>
            <ul class="flex column gap10 table-like">
              <li>
                <p>{{$t('name')}}</p>
                <p>{{$t('releaseTypes')}}</p>
                <p>{{$t('templateType')}}</p>
                <p>{{$t('hadlebarsFilePath')}}</p>
                <p>{{$t('appName')}}</p>
                <p>{{$t('url')}}</p>
                <!-- <p>{{$t('previewUrl')}}</p> -->
                <!-- <p>{{$t('appName')}}</p> -->
                <p></p>
              </li>
              <li v-for="(curr, idx) in organizationToEdit.templates || []" :key="idx">
                <FormInput type="text" placeholder="name" v-model="curr.name"/>
                <FormInput type="multiselect" :items="organizationToEdit.releaseTypes.map(({id, name}) => ({value: id, label: name}))" placeholder="releaseTypes" v-model="curr.releaseTypes"/>
                <FormInput type="select" :itemsMap="{landingPage: 'landingPage', email: 'email'}" placeholder="templateType" v-model="curr.type"/>
                <FormInput type="text" placeholder="hadlebarsFilePath" v-model="curr.handlebarsLocalFilePath"/>
                <FormInput type="select" :items="allClientAppsNames" placeholder="appName" v-model="curr.appName"/>
                <FormInput type="text" placeholder="url" v-model="curr.url"/>
                <!-- <FormInput type="text" placeholder="previewUrl" v-model="curr.previewUrl"/> -->
                <!-- <FormInput type="text" placeholder="appName" v-model="curr.appName"/> -->

                <!-- <FormInput type="textarea" placeholder="hadlebarsFileStr" v-model="curr.hadlebarsFileStr"/> -->
                <TableActionBtns v-model="organizationToEdit.templates" :idx="idx"/>
              </li>
            </ul>
            <button @click="addTemplateItem" class="btn big">{{$t('add')}}</button>
          </div>
        </div>
      </div>
    </form>
    <div class="flex width-all gap10 form-footer space-between align-center">
      <div class="flex gap30 align-center">
        <button class="btn big" @click="close">{{$t('cancel')}}</button>
        <button class="btn big primary" @click="saveAndClose" :disabled="!isOrganizationValid">{{$t('saveAndClose')}}</button>
        <button class="btn big primary" @click="saveOrganization" :disabled="!isOrganizationValid">{{$t('save')}}</button>
      </div>
      <button class="btn big danger clear" @click="deleteOrg" v-if="organizationToEdit._id && isLoggedUserAdmin">{{$t('delete')}}</button>
    </div>
    <Loader v-if="isLoading" fullScreen/>
  </div>
</template>

<script>
import FormInput from '@/apps/common/modules/common/cmps/FormInput.vue'
// import { uploadImg } from '../../common/services/util.service'
import { Utils } from '../../../../common/modules/common/services/util.service'
import FileUploader from '@/apps/common/modules/common/cmps/file/FileUploader.vue';
import TableActionBtns from '../../../../common/modules/common/cmps/TableActionBtns.vue';
import { templateUtils } from '../../../../common/modules/common/services/template.util.service';
import { organizationService } from '../services/organization.service';
import { consts } from '@/apps/common/modules/common/services/const.service.js';
import Loader from '@/apps/common/modules/common/cmps/Loader.vue';
import ToggleModal from '../../../../common/modules/common/cmps/ToggleModal.vue';
import { ClientApps } from '../../../..';
import ImageCrop from '../../release/cmps/DynamicFormInputs/ImageCrop.vue';
import { alertService } from '@/apps/common/modules/common/services/alert.service';
import { DEFAULT_SIMPLE_SCHEMA_TEMPLATE } from '../services/defaultOrgSchemaTemplates'


import allDefaultThemes from '../../../themes/index';

export default {
  name: 'OrganizationEdit',
  data() {
    return {
      itemBeforeEdit: null,
      organizationToEdit: null,
      showDeveloperZone: false,
      allDomains: [],
      isHydratingSchemaWizard: false,

      allDefaultThemes: allDefaultThemes.map(c => ({label: c.name, value: c})),
      allTemplateTypes: templateUtils.getAllTemplateTypes(),

      schemaWizard: this.getEmptySchemaWizardState()
    }
  },
  computed: {
    isNewOrg() {
      return !this.organizationToEdit?._id
    },
    schemaWizardElementRows() {
      const heroRows = [
        {
          key: 'title',
          state: this.schemaWizard.elements.title,
          labelKey: 'organizationLocales.templateWizard.stage1TitleField'
        },
        {
          key: 'subTitle',
          state: this.schemaWizard.elements.subTitle,
          labelKey: 'organizationLocales.templateWizard.stage1SubTitleField'
        },
        {
          key: 'mainImage',
          state: this.schemaWizard.elements.mainImage,
          labelKey: 'organizationLocales.templateWizard.stage1MainImageField'
        },
        {
          key: 'content',
          state: this.schemaWizard.elements.content,
          labelKey: 'organizationLocales.templateWizard.stage1ContentField'
        },
      ]

      const sectionRows = [
        {
          key: 'section:textItems',
          state: this.schemaWizard.sectionTypes.textItems,
          labelKey: 'organizationLocales.templateWizard.elements.section.textItems'
        },
        {
          key: 'section:images',
          state: this.schemaWizard.sectionTypes.images,
          labelKey: 'organizationLocales.templateWizard.elements.section.images'
        },
        {
          key: 'section:videos',
          state: this.schemaWizard.sectionTypes.videos,
          labelKey: 'organizationLocales.templateWizard.elements.section.videos'
        },
        {
          key: 'section:links',
          state: this.schemaWizard.sectionTypes.links,
          labelKey: 'organizationLocales.templateWizard.elements.section.links'
        }
      ]

      // Stage 2 should only show controls for enabled items.
      const enabledHeroRows = heroRows.filter(r => r.state?.enabled)
      const enabledSectionRows = sectionRows.filter(r => r.state?.enabled)

      return this.schemaWizard.elements.sections.enabled ? [...enabledHeroRows, ...enabledSectionRows] : enabledHeroRows
    },
    sectionsOrderEffective() {
      if (!this.schemaWizard.elements.sections.enabled) return []
      return (this.schemaWizard.sectionsOrder || []).filter(sec => this.schemaWizard.sectionTypes?.[sec]?.enabled)
    },
    isLoggedUserAdmin() {
      return this.loggedUser?.roles.includes('admin');
    },
    isLoggedUserDeveloper() {
      return this.loggedUser?.roles.includes('developer');
    },
    userRolesToSelect: () => [...Object.values(consts.organizationRoles)].slice(1),
    isOrganizationValid() {
      const item = this.organizationToEdit;
      return !!item && !this.isDomainExistsError;
    },
    loggedUser() {
      return this.$store.getters['auth/loggedUser'];
    },
    // defaultTemplateTypesIds() {
    //   return templateUtils.DEFAULY_TEMPLATES_DATA.templates.map(c => c.id);
    // },
    allReleaseTypes() {
      // return templateUtils.getAllReleaseTypesForOrg(this.organizationToEdit);
      // return templateUtils.getAllReleaseTypesForOrg(this.organizationToEdit);
      return templateUtils.getBaseOrgTEmplatesDataByOtgType(this.organizationToEdit.type).releaseTypes;
    },

    otherDomains() {
      return this.allDomains.filter(d => d !== this.itemBeforeEdit?.domain);
    },
    isDomainExistsError() {
      return this.otherDomains.includes(this.organizationToEdit.domain);
    },
    isLoading() {
      return this.$store.getters['organization/isLoading'];
    },

    allClientAppsNames() {
      return [...ClientApps.map(c => c.name), {label: '- None -', value: ''}];
    },
    videoEncodingPresetOptions() {
      return [
        { label: this.$t('organizationLocales.videoEncodingPreset720p'), value: '720p' },
        { label: this.$t('organizationLocales.videoEncodingPreset1080p'), value: '1080p' },
        { label: this.$t('organizationLocales.videoEncodingPresetAuto'), value: 'auto' },
        { label: this.$t('organizationLocales.videoEncodingPresetPassthrough'), value: 'passthrough' }
      ]
    },
    
    didChange() {
      return JSON.stringify(this.organizationToEdit) !== JSON.stringify(this.itemBeforeEdit);
    },

    designTemplateId: {
      get() {
        const firstItemId = this.organizationToEdit?.releaseTypes?.[0]?.id || '';
        return this.organizationToEdit?.defaultTemplates?.[firstItemId]?.landingPage || '';
      },
      set(val) {
        for (let key in this.organizationToEdit.defaultTemplates) {
          this.organizationToEdit.defaultTemplates[key]['landingPage'] = val;
        }
      }
    }
  },
  methods: {
    getEmptySchemaWizardState() {
      return {
        enabled: true,
        startMode: 'template', // 'blank' | 'template'
        elements: {
          title: { enabled: true, label: '', showTitle: false },
          subTitle: { enabled: true, label: '', showTitle: false },
          mainImage: { enabled: true, label: '', showTitle: false },
          content: { enabled: true, label: '', showTitle: false },
          sections: { enabled: true }
        },
        sectionTypes: {
          textItems: { enabled: true, label: '', showTitle: false },
          images: { enabled: true, label: '', showTitle: false },
          videos: { enabled: true, label: '', showTitle: false },
          links: { enabled: true, label: '', showTitle: false }
        },
        sectionsOrder: ['textItems', 'images', 'videos', 'links']
      }
    },
    syncSchemaWizardDefaultsForStartMode(startMode) {
      if (!this.schemaWizard) return

      if (startMode === 'blank') {
        this.schemaWizard.elements.title.label = ''
        this.schemaWizard.elements.subTitle.label = ''
        this.schemaWizard.elements.mainImage.label = ''
        this.schemaWizard.elements.content.label = ''
        this.schemaWizard.elements.title.showTitle = false
        this.schemaWizard.elements.subTitle.showTitle = false
        this.schemaWizard.elements.mainImage.showTitle = false
        this.schemaWizard.elements.content.showTitle = false

        this.schemaWizard.sectionTypes.textItems.label = ''
        this.schemaWizard.sectionTypes.images.label = ''
        this.schemaWizard.sectionTypes.videos.label = ''
        this.schemaWizard.sectionTypes.links.label = ''
        this.schemaWizard.sectionTypes.textItems.showTitle = false
        this.schemaWizard.sectionTypes.images.showTitle = false
        this.schemaWizard.sectionTypes.videos.showTitle = false
        this.schemaWizard.sectionTypes.links.showTitle = false
        return
      }

      // Template-based defaults (store Hebrew literals so landing renderer can show labels)
      this.schemaWizard.elements.title.label = this.$t('dataFieldsLocales.title') || 'title'
      this.schemaWizard.elements.subTitle.label = this.$t('dataFieldsLocales.subTitle') || 'subTitle'
      this.schemaWizard.elements.mainImage.label = this.$t('dataFieldsLocales.mainImage') || 'mainImage'
      this.schemaWizard.elements.content.label = this.$t('dataFieldsLocales.content') || 'content'
      this.schemaWizard.elements.title.showTitle = false
      this.schemaWizard.elements.subTitle.showTitle = false
      this.schemaWizard.elements.mainImage.showTitle = false
      this.schemaWizard.elements.content.showTitle = false

      this.schemaWizard.sectionTypes.textItems.label = this.$t('dataFieldsLocales.textItems') || 'textItems'
      this.schemaWizard.sectionTypes.images.label = this.$t('dataFieldsLocales.images') || 'images'
      this.schemaWizard.sectionTypes.videos.label = this.$t('dataFieldsLocales.videos') || 'videos'
      this.schemaWizard.sectionTypes.links.label = this.$t('dataFieldsLocales.links') || 'links'
      this.schemaWizard.sectionTypes.textItems.showTitle = true
      this.schemaWizard.sectionTypes.images.showTitle = true
      this.schemaWizard.sectionTypes.videos.showTitle = true
      this.schemaWizard.sectionTypes.links.showTitle = true
    },
    sectionTypeLabelKey(sectionType) {
      const map = {
        textItems: 'organizationLocales.templateWizard.elements.section.textItems',
        images: 'organizationLocales.templateWizard.elements.section.images',
        videos: 'organizationLocales.templateWizard.elements.section.videos',
        links: 'organizationLocales.templateWizard.elements.section.links'
      }
      return map[sectionType] || sectionType
    },
    updateSectionsOrderEffective(newEffectiveOrder) {
      // Keep disabled section types in their existing relative order.
      const disabled = (this.schemaWizard.sectionsOrder || []).filter(sec => !this.schemaWizard.sectionTypes?.[sec]?.enabled)
      this.schemaWizard.sectionsOrder = [...newEffectiveOrder, ...disabled]
    },
    clone(obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    buildSchemaWizardTemplate() {
      const wiz = this.schemaWizard
      const base = wiz.startMode === 'blank' ? [] : this.clone(DEFAULT_SIMPLE_SCHEMA_TEMPLATE)

      const ensureSections = () => {
        if (base.find(f => f.fieldName === 'sections')) return
        const templateSections = this.clone(DEFAULT_SIMPLE_SCHEMA_TEMPLATE).find(f => f.fieldName === 'sections')
        if (templateSections) base.push(templateSections)
      }
      const ensureHeroFields = () => {
        const heroFieldNames = ['title', 'subTitle', 'mainImage', 'content']
        const defaults = this.clone(DEFAULT_SIMPLE_SCHEMA_TEMPLATE)
        for (const name of heroFieldNames) {
          if (base.find(f => f.fieldName === name)) continue
          const def = defaults.find(f => f.fieldName === name)
          if (def) base.push(def)
        }
      }
      // Editor must always be able to create/edit these fields.
      // The wizard only controls label/caption visibility (via title + hideTitleFromUi).
      ensureHeroFields()
      ensureSections()

      const applyField = (fieldName, state) => {
        const field = base.find(f => f.fieldName === fieldName)
        if (!field) return
        const mandatoryHeroFields = new Set(['title', 'subTitle', 'mainImage', 'content'])
        const enabled = mandatoryHeroFields.has(fieldName) ? true : !!state.enabled
        field.disabled = !enabled

        // Respect empty string: '' means "no title", not fallback to default.
        if (typeof state.label !== 'undefined') field.title = state.label
        if (typeof state.showTitle !== 'undefined') field.hideTitleFromUi = !state.showTitle
      }

      applyField('title', wiz.elements.title)
      applyField('subTitle', wiz.elements.subTitle)
      applyField('mainImage', wiz.elements.mainImage)
      applyField('content', wiz.elements.content)
      applyField('sections', wiz.elements.sections)

      const sectionsField = base.find(f => f.fieldName === 'sections')
      if (wiz.elements.sections.enabled && sectionsField?.fieldOpts?.length) {
        const allowed = new Set(Object.keys(wiz.sectionTypes).filter(k => wiz.sectionTypes[k].enabled))
        sectionsField.fieldOpts = sectionsField.fieldOpts.filter(opt => {
          const typeField = opt.find(c => c.type === 'TYPE')
          const type = typeField?.defaultValue
          return allowed.has(type)
        })
        // Apply titles + showTitle on the section header "title" field
        sectionsField.fieldOpts.forEach(opt => {
          const typeField = opt.find(c => c.type === 'TYPE')
          const type = typeField?.defaultValue
          const conf = wiz.sectionTypes[type]
          if (!conf) return
          const titleField = opt.find(c => c.fieldName === 'title' && c.type === 'TEXT')
          if (titleField) {
            if (typeof conf.label !== 'undefined') titleField.title = conf.label
            titleField.hideTitleFromUi = !conf.showTitle
          }
        })
      }

      return base
        .filter(f => f.type === 'SEPARATOR' || f.fieldName) // keep separators and valid fields
    },
    applySchemaWizardToOrg() {
      if (!this.schemaWizard?.enabled) return
      const releaseTypeId = this.organizationToEdit?.releaseTypes?.[0]?.id
      if (!releaseTypeId) return

      const dataFields = this.buildSchemaWizardTemplate()

      if (!this.organizationToEdit.schemaTemplates) {
        this.$set(this.organizationToEdit, 'schemaTemplates', {})
      }
      this.$set(this.organizationToEdit.schemaTemplates, releaseTypeId, {
        version: 1,
        dataFields,
        tabsOrder: this.schemaWizard.elements.sections.enabled ? [...this.schemaWizard.sectionsOrder] : []
      })
      this.organizationToEdit.templateMode = 'schema'
    },
    loadSchemaWizardFromOrg(org) {
      try {
        if (!org || org.templateMode !== 'schema') return
        this.isHydratingSchemaWizard = true
        this.schemaWizard.enabled = true
        const releaseTypeId = org?.releaseTypes?.[0]?.id
        if (!releaseTypeId) return
        const schemaTemplate = org?.schemaTemplates?.[releaseTypeId]
        const dataFields = schemaTemplate?.dataFields
        if (!Array.isArray(dataFields)) return

        // Hydrate from saved schema
        const fieldByName = (name) => dataFields.find(f => f?.fieldName === name)
        const heroFieldNames = ['title', 'subTitle', 'mainImage', 'content']

        heroFieldNames.forEach(fieldName => {
          const def = fieldByName(fieldName)
          if (!def) return
          this.schemaWizard.elements[fieldName].enabled = true // mandatory fields
          this.schemaWizard.elements[fieldName].label = typeof def.title !== 'undefined' ? def.title : ''
          this.schemaWizard.elements[fieldName].showTitle = !def.hideTitleFromUi
        })

        const sectionsField = fieldByName('sections')
        const sectionsEnabled = !sectionsField?.disabled
        this.schemaWizard.elements.sections.enabled = !!sectionsEnabled

        // Hydrate section types from LIST->fieldOpts TYPE defaultValue
        const allSectionTypes = ['textItems', 'images', 'videos', 'links']
        const fieldOpts = sectionsField?.fieldOpts || []
        allSectionTypes.forEach(type => {
          const opt = fieldOpts.find(optArr => (optArr || []).some(c => c?.type === 'TYPE' && c?.defaultValue === type))
          const titleField = opt?.find(c => c?.fieldName === 'title' && c?.type === 'TEXT')
          const enabled = !!opt
          this.schemaWizard.sectionTypes[type].enabled = enabled
          this.schemaWizard.sectionTypes[type].label = typeof titleField?.title !== 'undefined' ? titleField?.title : ''
          this.schemaWizard.sectionTypes[type].showTitle = enabled ? !titleField?.hideTitleFromUi : false
        })

        if (Array.isArray(schemaTemplate?.tabsOrder)) this.schemaWizard.sectionsOrder = [...schemaTemplate.tabsOrder]
      } catch (err) {
        console.warn('Failed to load schema wizard from org', err)
      } finally {
        this.isHydratingSchemaWizard = false
      }
    },
    getAllRelevantTemplatesForReleaseType() {
      return templateUtils.getAllRelevantTemplatesForReleaseType(...arguments);
    },
    async getOrganization() {
      this.organizationToEdit = await this.$store.dispatch({ type: 'organization/loadItem', id: this.$route.params.id, isToInheritData: true });
      if (!this.organizationToEdit._id) {
        this.organizationToEdit.type = this.$store.getters.envManagement?.defaultOrgType || 'tvProducer';
        this.inheritOrgTypeData();
      }
      this.setupDefaultTemplateMap();
      // for (let designAppKey in this.organizationToEdit.designPreferences) { // temp fix;
      //   if (typeof this.organizationToEdit.designPreferences[designAppKey] !== 'object') continue;
      //   this.organizationToEdit.designPreferences[designAppKey].forEach(theme => {
      //     if (!theme.colors) return;
      //     if (theme.colors.length === 8) {
      //       theme.colors[5] = theme.colors[6];
      //       theme.colors[6] = theme.colors[7];
      //       theme.colors.splice(7, 1);
      //     }
      //     // if (!theme.colors[6]) theme.colors[6] = '#2090d4';
      //     // if (!theme.colors[7]) theme.colors[7] = 'rgba(102, 102, 102, 1)';
      //   });
      // }
      this.itemBeforeEdit = JSON.parse(JSON.stringify(this.organizationToEdit));
    },
    async getAllDomains() {
      this.allDomains = await this.$store.dispatch({ type: 'organization/loadAllDomainNames' });
    },
    async saveOrganization() {
      if (!this.isOrganizationValid) return;
      const isNew = !this.organizationToEdit._id;
      if (isNew || this.organizationToEdit.templateMode === 'schema') this.applySchemaWizardToOrg()
      this.organizationToEdit = JSON.parse(JSON.stringify(await this.$store.dispatch({ type: 'organization/saveItem', item: this.organizationToEdit })));
      this.itemBeforeEdit = JSON.parse(JSON.stringify(this.organizationToEdit));
      if (isNew) this.$router.push({params: {id: this.organizationToEdit._id}});
      console.log('SAVED ORGANIZATION', this.organizationToEdit);
    },
    async saveAndClose() {
      await this.saveOrganization();
      this.close();
    },
    close() {
      this.$router.push({ name: 'OrganizationPage', params: { organizationId: this.$route.params.organizationId } })
    },

    async imgUploaded(imgsrc, pathToSet) {
      // const uploadedImg = await imgUploaded(imgsrc);
      Utils.setDeepVal(this.organizationToEdit, pathToSet, imgsrc);
    },


    addFromEmailItem() {
      if (!this.organizationToEdit.fromEmails) this.organizationToEdit.fromEmails = [];
      this.organizationToEdit.fromEmails.push({ title: '', email: '' });
    },
    addRouteFilterItem() {
      if (!this.organizationToEdit.routes) this.organizationToEdit.routes = [];
      this.organizationToEdit.routes.push(organizationService.createEmptyRouteItem());
    },
    addInnerFilterItem() {
      if (!this.organizationToEdit.innerFilters) this.organizationToEdit.innerFilters = [];
      this.organizationToEdit.innerFilters.push(organizationService.createEmptyInnerFilterItem());
    },
    addReleaseTypeItem() {
      if (!this.organizationToEdit.releaseTypes) this.organizationToEdit.releaseTypes = [];
      this.organizationToEdit.releaseTypes.push(organizationService.createEmptyReleaseTypeItem());
      this.setupDefaultTemplateMap();
    },
    addTemplateItem() {
      if (!this.organizationToEdit.templates) this.organizationToEdit.templates = [];
      this.organizationToEdit.templates.push(organizationService.createEmptyTemplateItem());
    },
    addLogoItem() {
      if (!this.organizationToEdit.logos) this.organizationToEdit.logos = [];
      this.organizationToEdit.logos.push({url: '', id: Utils.getRandomId(), title: ''});
    },
    AddMediaLinkItem() {
      if (!this.organizationToEdit.mediaLinks) this.organizationToEdit.mediaLinks = [];
      this.organizationToEdit.mediaLinks.push({src: '', id: Utils.getRandomId(), type: '', title: ''});
    },
    addTheme(themesArr) {
      themesArr.push(organizationService.getEmptyThemeItem());
    },

    inheritTheme(theme, themeToInherit) {
      // for (let key in theme) {
      //   theme[key] = inheritTheme[key]
      // }
      if (themeToInherit.name) theme.name = themeToInherit.name;
      if (themeToInherit.css) theme.css = themeToInherit.css;
      if (themeToInherit.colors) theme.colors = [...themeToInherit.colors];
      if (themeToInherit.fonts) theme.fonts = [...themeToInherit.fonts];
      // this.$forceUpdate();
    },

    setupDefaultTemplateMap() {
      if (!this.organizationToEdit.defaultTemplates) {
        this.$set(this.organizationToEdit, 'defaultTemplates', {});
        // this.organizationToEdit.defaultTemplates = {};
      }
      for (let releaseType of this.organizationToEdit.releaseTypes) {
        if (!this.organizationToEdit.defaultTemplates[releaseType.id]) {
          // this.organizationToEdit.defaultTemplates[releaseType.id] = 
          const newCurrMap = this.allTemplateTypes.reduce((acc, c) => ({
            ...acc, [c]: this.getAllRelevantTemplatesForReleaseType(releaseType.id, this.organizationToEdit, c, true)[0]?.id || ''
          }), {});
          this.$set(this.organizationToEdit.defaultTemplates, releaseType.id, newCurrMap);
        }
      }
    },

    inheritOrgTypeData(orgType) {
      this.this.organizationToEdit = orgType;
      this.organizationToEdit = {
        ...this.organizationToEdit,
        ...organizationService.getOrgTypeDefaultReleaseTypeData(this.organizationToEdit)
      }
      this.organizationToEdit.defaultTemplates = {};
      this.setupDefaultTemplateMap();
    },

    async deleteOrg() {
      await this.$store.dispatch({ type: 'organization/removeItem', id: this.organizationToEdit._id });
      this.close();
    }
  },
  created() {
    this.getOrganization();
    this.getAllDomains();
    this.syncSchemaWizardDefaultsForStartMode(this.schemaWizard.startMode);
  },
  async beforeRouteLeave(to, from, next) {
    if (!this.didChange) return next();
    const doesWantToLeave = await alertService.Confirm(this.$t('releaseLocales.alerts.leaveConfirm'), undefined, '<style>.A-Alert .alert-modal .a-alert-confirm-btn {border: none !important; box-shadow: none !important;}</style>');
    if (!doesWantToLeave) return next(false);
    else return next(true);
  },
  watch: {
    'schemaWizard.startMode': {
      immediate: true,
      handler(startMode) {
        if (this.isHydratingSchemaWizard) return
        this.syncSchemaWizardDefaultsForStartMode(startMode)
      }
    },
    '$route.params.id'() {
      this.getOrganization();
    },
    organizationToEdit: {
      immediate: true,
      handler(org) {
        if (org) {
          // Initialize features object if it doesn't exist
          if (!org.features) {
            this.$set(org, 'features', {
              encryptedVideosSection: false,
              releaseLevel2FA: false,
              itemLevelPermissions: false
            })
          }
          // Initialize storage object if it doesn't exist
          if (!org.storage) {
            this.$set(org, 'storage', {
              imagesBucketConfig: '',
              videosBucketConfig: '',
              useSignedUrls: undefined,
              videoEncodingPreset: '720p' // Default to 720p for backward compatibility
            })
          } else if (!org.storage.videoEncodingPreset) {
            // Set default if preset is missing
            this.$set(org.storage, 'videoEncodingPreset', '720p')
          }

          // Hydrate wizard state only for schema-mode orgs.
          if (org.templateMode === 'schema') this.loadSchemaWizardFromOrg(org)
        }
      }
    }
  },
  components: {
    FormInput,
    FileUploader,
    TableActionBtns,
    Loader,
    ToggleModal,
    ImageCrop
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/global/index';
.megaphon-app {
  .organization-edit {
    padding: em(20px) 0;
    form, .developer-zone {
      width: 100%;
      >* {
        width: 100%;
        padding-bottom: em(10px);
        border-bottom: em(1px) solid var(--clr-0);
      }
    }
    .contact-msg-input {
      .input {
        height:400px;
        width:400px;
      }
    }
    .table-like {
      // width: 100%;
      // overflow-x: auto;
      // max-width: 100%;
      max-width: 95vw;
      li {
        width: 100%;
        // display: grid;
        // grid-template-columns: auto;
        // gap: em(10px);
        display: flex;
        align-items: flex-start;
        gap: em(10px);

        width: 100%;
        >* {
          flex: 1;
          width: em(200px);
          &:last-child {
            flex: unset;
            width: em(100px);
          }
        }
      }
    }

    .logos-section {
      li {
        display: flex;
        align-items: flex-start;
        gap: em(10px);
        width: 100%;
        >* {
          flex: unset;
        }
        >:first-child {
          width: em(200px);
          // &:last-child {
          //   flex: unset;
          // }
        }
        >:nth-child(2) {
          width: em(325px);
          // &:last-child {
          //   flex: unset;
          // }
        }
      }
    }

    .input-container {
      display: flex;
      align-items: center;
      >p {
        width: em(200px);
      }
      .form-input {
        flex: 1;
      }
    }

    .template-wizard-card {
      width: 100%;
      padding: em(16px);
      border: em(1px) solid var(--clr-0);
      border-radius: em(12px);
      background: rgba(0, 0, 0, 0.02);
    }

    .template-wizard-title {
      font-weight: 700;
      margin-bottom: em(12px);
    }

    .template-wizard-section {
      font-weight: 650;
    }

    .template-wizard-divider {
      padding-top: em(10px);
      border-top: em(1px) solid var(--clr-0);
      margin-top: em(4px);
    }

    .template-wizard-subsection {
      font-weight: 600;
      opacity: 0.95;
    }

    .template-wizard-row-key {
      flex: 0 0 auto;
      min-width: em(140px);
      width: em(140px);
      text-align: start;
    }

    .code-edit-modal {
      .actual-input {
        width: 60vw;
        height: 60vh;
        .input {
          width: 100%;
          height: 100% !important;
        }
      }
    }
  }
}
</style>